import React, { useEffect, useState } from 'react';
import { SpotlightTransition } from '@atlaskit/onboarding';
import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
import { ScheduleSpotlights } from '@atlassian/eoc-on-call';
import { useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import { commonMessages } from '../../../common/messages.tsx';
import { messages } from './messages.tsx';

type Props = {
	// eslint-disable-next-line jira/react/handler-naming
	stop?: () => void;
};

export const ShiftTileTour = ({ stop }: Props) => {
	const { formatMessage } = useIntl();
	const [activeSpotlight, setActiveSpotlight] = useState<null | number>(null);
	const start = () => setActiveSpotlight(0);
	const end = () => setActiveSpotlight(null);

	useEffect(() => {
		start();
	}, []);

	const dismiss = () => {
		end();

		if (stop) {
			stop();
		}
	};

	const renderActiveSpotlight = () => {
		const spotlights = [
			<JiraSpotlight
				actions={[{ onClick: dismiss, text: formatMessage(commonMessages.ok) }]}
				heading={formatMessage(messages.selectAnyShift)}
				target={ScheduleSpotlights.shiftTile}
				key={ScheduleSpotlights.shiftTile}
				dialogPlacement="top center"
				targetRadius={6}
				targetBgColor={token('elevation.surface', N0)}
				messageId="eoc-on-call.ui.tours.shift-tile.jira-spotlight"
				messageType="engagement"
			>
				{formatMessage(messages.viewSummaryOfShift)}
			</JiraSpotlight>,
		];

		if (activeSpotlight === null) {
			return null;
		}

		return spotlights[activeSpotlight];
	};

	return <SpotlightTransition>{renderActiveSpotlight()}</SpotlightTransition>;
};
